// apps/portal/src/impianti/impianti.api.ts
import { supabase } from '../lib/supabase'
import { condizioneFiltro } from './filtri'
import { statoAcciseMensili, ETICHETTA_STATO_ACCISE, type RataAccisa } from '../accise/stato-accise'

export interface RigaElenco {
  readonly id: number
  readonly codiceImpianto: string | null
  readonly codiceDichiarazione: string
  readonly tipologia: string
  readonly stato: string
  readonly ragioneSociale: string
  readonly operatore: string | null
  readonly statoUltimaDichiarazione: string | null
  readonly statoAcciseMensili: string
}

export function costruisciQuery(filtro: string | null, aziendaId: number | null = null) {
  let query = supabase.from('vista_elenco_impianti').select('*')
  if (filtro) {
    const { campo, valore } = condizioneFiltro(filtro)
    query = query.eq(campo, valore)
  }
  return aziendaId === null ? query : query.eq('aziendaId', aziendaId)
}

export async function caricaElenco(filtro: string | null, aziendaId: number | null = null): Promise<RigaElenco[]> {
  const { data, error } = await costruisciQuery(filtro, aziendaId)
  if (error) throw new Error(error.message)
  return (data ?? []).map((r: Record<string, unknown>) => {
    const { acciseMensili, ...resto } = r
    return {
      ...resto,
      statoAcciseMensili: ETICHETTA_STATO_ACCISE[statoAcciseMensili((acciseMensili ?? []) as RataAccisa[])],
    }
  }) as RigaElenco[]
}
